import { useMutation, UseMutationResult } from "@tanstack/react-query"
import { Creators } from "model/apiWrapper"
import { useDispatch } from "react-redux"

export interface PinWorkflowArgs {
  accountAlias: string
  artifactId: string
  title: string
}

export interface PinWorkflowResult {
  pinnedId: string
}

/**
 * Hook to pin an AI artifact as a workflow
 *
 * Makes a POST request to create a pinned workflow from an artifact,
 * returning the pinnedId which can be used to fetch the artifact later.
 */
export function usePinWorkflow(): UseMutationResult<PinWorkflowResult, Error, PinWorkflowArgs> {
  const dispatch = useDispatch()

  return useMutation<PinWorkflowResult, Error, PinWorkflowArgs>({
    mutationFn: ({ accountAlias, artifactId, title }) =>
      new Promise<PinWorkflowResult>((resolve, reject) => {
        dispatch(Creators.post(
          `/api/${accountAlias}/ai/pin-workflow`,
          { artifactId, title },
          resolve,
          reject,
        ))
      }),
  })
}
